import React from 'react';
import FooterLegalNav from './FooterLegalNav';

/**
 * App shell footer — stays in document flow (not fixed) so main content never overlaps it.
 *
 * @param {{ year: number, monthYear: string, onAppTour?: () => void }} props
 */
export default function LayoutFooter({ year, monthYear, onAppTour }) {
  return (
    <footer className="layout-footer relative z-10 flex-shrink-0 border-t border-gray-200 bg-white py-1 safe-area-bottom dark:border-gray-800 dark:bg-black">
      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-0.5 px-3 text-ds-caption leading-tight max-md:gap-x-2 md:px-4 lg:px-6">
        <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-0.5 max-md:gap-x-2">
          <p className="text-gray-500 dark:text-gray-400">
            © {year} Kadel Labs. All rights reserved.
          </p>
          <div className="flex items-center gap-x-2 text-ds-caption text-gray-500 dark:text-gray-400">
            {onAppTour ? (
              <button
                type="button"
                onClick={onAppTour}
                className="cursor-pointer font-medium text-blue-600 hover:text-blue-700 hover:underline dark:text-blue-400 dark:hover:text-blue-300"
                aria-label="Start app tour"
                data-walkthrough="footer-app-tour"
              >
                v2.6.0
              </button>
            ) : (
              <span>v2.6.0</span>
            )}
            <span aria-hidden="true">•</span>
            <span className="whitespace-nowrap">{monthYear}</span>
          </div>
        </div>
        <FooterLegalNav
          className="shrink-0 text-gray-500 dark:text-gray-400"
          linkClassName="hover:text-gray-700 dark:hover:text-gray-300"
        />
      </div>
    </footer>
  );
}
